
import { defineComponent, PropType, ref, onMounted, computed, onBeforeUpdate } from 'vue'

interface Section {
  name: string
  items: any[]
}

export default defineComponent({
  props: {
    idPrefix: {
      type: String,
      default: 'AccordionSection',
    },
    data: {
      type: Array as PropType<Array<Section>>,
      default: () => [],
    },
    topOffset: {
      type: Number,
      default: 0,
    },
  },
  emits: ['item-click'],
  setup(props) {
    const root = ref()
    const inner = ref()
    const fixedTitle = ref(props.data && props.data[0]?.name)
    const fixedTitleTop = ref(0)
    const fixedTitleZIndex = ref(0)
    const fixedTitleStyle = computed(() => ({
      'z-index': fixedTitleZIndex.value,
    }))

    let sections: HTMLElement[] = []

    const updateUi = () => {
      if (sections.length <= 1) {
        return
      }

      const rects = sections.map((el) => el.getBoundingClientRect())
      let currentSectionIndex = 0

      for (let i = rects.length - 1; i >= 0; i--) {
        if (rects[i].top <= props.topOffset) {
          currentSectionIndex = i
          break
        }
      }

      fixedTitleZIndex.value = currentSectionIndex + 1
      fixedTitle.value = props.data[currentSectionIndex].name
    }

    const setSectionRefs = (el: HTMLElement) => {
      sections.push(el)
    }

    const onScroll = () => {
      updateUi()
    }

    onBeforeUpdate(() => {
      sections = []
    })

    onMounted(() => {
      updateUi()
    })

    const scrollToSection = (i: number) => {
      inner.value.scrollTo(0, sections[i].offsetTop)
    }

    return {
      root,
      inner,
      fixedTitle,
      fixedTitleTop,
      fixedTitleZIndex,
      fixedTitleStyle,
      setSectionRefs,
      onScroll,
      scrollToSection,
    }
  },
})
